export default __webpack_public_path__ + "static/media/DSC_0803.238dc727.JPG";